import {Request} from './Request';

export class GetLocalListVersionRequest implements Request {
    chargePointSelectList: string[];

    constructor(chargePointSelectList: string[]) {
        this.chargePointSelectList = chargePointSelectList;
    }

    public toString = (): string => {
        return `GetLocalListVersionRequest (chargePointSelectList: ${this.chargePointSelectList}`;
    }
}
